module.exports = __webpack_public_path__ + "static/media/Ski.d268b859.PNG";